(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('footerToolbar', function(
    urlUtils,
    $rootScope,
    preferences,
    imageService,
    $timeout,
    arrayUtil,
    hotelRehydrator,
    broker,
    $q,
    recentHotels,
    shortlistService,
    resourceService,
    savedSearchService,
    basketService,
    analytics
    ) {
        return {
            restrict: 'E',
            templateUrl: 'partials/home/directivetemplate?type=FooterToolbar',
            link(scope) {
                scope.open = false;
                scope.$on('auth:signout', fetch);
                scope.$on('auth:signin', fetch);
                scope.stripLeadingSlash = urlUtils.stripLeadingSlash;

                let initialised = false;
                let busy = false;
                const icons = {
                    1: 'icon-flight',
                    3: 'icon-holidays',
                    2: 'icon-hotel',
                    4: 'icon-transfer',
                    6: 'icon-parking'
                };
                const sectionIndex = {
                    recentHotels: 0,
                    shortlist: 1,
                    savedSearches: 2
                };

                $rootScope.$on('$routeChangeSuccess', function(event, current) {
                    scope.hide = current.hideDistractionLinks;
                    if (initialised) {
                        closeAllSections();
                    } else if (!scope.hide) {
                        init();
                    }
                });

                if (!scope.rc.hideDistractionLinks) {
                    init();
                }

                function addHotelToSection(section, hotel) {
                    if (section == null || section.things == null) {
                        return;
                    }

                    //make sure this hotel is not already in the list
                    if (arrayUtil.any(section.things, function(t) {
                        return t.Id === hotel.Id && !t.deleted;
                    }) || arrayUtil.any(section.estabIds, function(estabId) {
                        return estabId === hotel.Id;
                    })) {
                        return;
                    }

                    if (hotel.Name == null) {
                        hotel.Name = hotel.Title;
                    }
                    hotel.ImageUrl = imageService.getMainImageUrl(hotel.Id, 80, 80);

                    hotel.hide = true;
                    hotel.deleted = false;
                    hotel.new = true;
                    section.things.unshift(hotel);
                    $timeout(function() {
                        hotel.hide = false;
                        section.count += 1;
                    }, 0);
                }

                function removeHotelFromSection(section, hotel) {
                    for (let i = 0, l = section.things.length; i < l; i++) {
                        if (section.things[i].Id === hotel.Id) {
                            section.count -= 1;
                            section.things[i].hide = true;
                            section.things[i].deleted = true;
                            break;
                        }
                    }
                }

                function setToolbarOpen(isOpen) {
                    scope.open = isOpen;
                    preferences.set('footerToolbar', scope.open);
                }

                function deleteSearch(s, ev) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    savedSearchService.removeSavedSearch(s.SavedSearchId);
                    scope.sections[2].count -= 1;
                    removeSearch(s);
                }

                function removeSearch(search) {
                    search.hide = true;
                    search.deleted = true;
                }

                function addSearch(section, s) {
                    //force close of search on add as element has no layout
                    if (scope.sections[2].open) {
                        scope.sections[2].open = false;
                    }

                    //make sure this search is not already in the list
                    let isSearchInTheList = arrayUtil.any(section.things, t => t.SavedSearchId === s.SavedSearchId && !t.deleted);
                    if (isSearchInTheList) {
                        return;
                    }

                    s.hide = true;
                    s.deleted = false;
                    s.new = true;
                    extendSearch(s);

                    section.things.unshift(s);
                    $timeout(function() {
                        s.hide = false;
                        section.count += 1;
                    }, 0);
                }

                function restoreSearch(s, ev) {
                    ev.preventDefault();
                    if (!busy) {
                        busy = true;
                        savedSearchService.restoreSearch(s).then(function() {
                            basketService.startWorkflow(basketService.workflowType[s.SearchType]).then(function() {
                                busy = false;
                                removeSearch(s);
                            });
                            analytics.trackEvent({ label: 'restore saved search' });
                        }, function() {
                            busy = false;
                        });
                    }
                }

                function rehydrateIfNecessaryAndThen(section, then, hotel) {
                    if (section.needsHydrating) {
                        rehydrate(section).then(function() {
                            then(section, hotel);
                        });
                    } else {
                        then(section, hotel);
                    }
                }

                function setupSubscriptions() {
                    broker.subscribe('footerToolbarDirective', 'hotelAddedToShortlist', function(ev) {
                        const hotel = angular.copy(ev.data);
                        hotel.onDelete = deleteFromShortlist;
                        rehydrateIfNecessaryAndThen(scope.sections[1], addHotelToSection, hotel);
                    });
                    broker.subscribe('footerToolbarDirective', 'hotelRemovedFromShortlist', function(ev) {
                        const hotel = ev.data;
                        hotel.inShortlist = false;
                        scope.$emit('hotelShortlistStatusUpdated', hotel);
                        rehydrateIfNecessaryAndThen(scope.sections[1], removeHotelFromSection, hotel);
                    });
                    broker.subscribe('footerToolbarDirective', 'recentHotelAdded', function(ev) {
                        rehydrateIfNecessaryAndThen(scope.sections[0], function(section, hotel) {
                            rehydrateHotel(section, hotel).then(function(hotel) {
                                addHotelToSection(section, hotel);
                            });
                        }, ev.data);
                    });
                    broker.subscribe('footerToolbarDirective', 'recentHotelRemoved', function(ev) {
                        rehydrateIfNecessaryAndThen(scope.sections[0], function(section, hotel) {
                            removeHotelFromSection(section, hotel);
                        }, { Id: ev.data });
                    });
                    broker.subscribe('footerToolbarDirective', 'savedSearchAdded', function(ev) {
                        addSearch(scope.sections[2], angular.copy(ev.data));
                    });
                    broker.subscribe('footerToolbarDirective', 'footerToolbarChanged', function(ev) {
                        scope.open = ev.data;
                    });
                }

                function closeAllSections() {
                    if (scope.sections) {
                        scope.sections.forEach(s => s.open = false);
                    }
                }


                function section(identifier, title, estabIds, things, emptyPrompt, icon, template, needsRehydrating, index, showCount, onDelete) {
                    return {
                        identifier,
                        title,
                        things: things || [],
                        estabIds: estabIds || [],
                        emptyPrompt,
                        count: estabIds.length || things.length || 0,
                        needsHydrating: needsRehydrating,
                        icon,
                        template,
                        index,
                        showCount,
                        onDelete
                    };
                }

                function deleteFromShortlist(hotel, ev) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    shortlistService.removeFromShortlist(hotel);
                }

                function shortlistSection(hotels) {
                    return section(
                        'shortlist',
                        resourceService.get('SHORTLIST'),
                        hotels,
                        [],
                        resourceService.get('NOSHORTLISTEDHOTELS'),
                        'favourite',
                        'partials/footertoolbar/toolbarhotel',
                        true,
                        sectionIndex.shortlist,
                        true,
                        deleteFromShortlist
                    );
                }

                function deleteFromRecent({ Id }, ev) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    recentHotels.remove(Id);
                }

                function recentHotelsSection(hotels) {
                    return section(
                        'recent',
                        resourceService.get('RECENTHOTELS'),
                        hotels,
                        [],
                        resourceService.get('NORECENTHOTELS'),
                        'timer',
                        'partials/footertoolbar/toolbarhotel',
                        true,
                        sectionIndex.recentHotels,
                        true,
                        deleteFromRecent
                    );
                }

                function savedSearchesSection(searches) {
                    return section(
                        'searches',
                        resourceService.get('RECENTSEARCHES'),
                        [],
                        arrayUtil.map(searches, extendSearch),
                        resourceService.get('NORECENTSEARCHES'),
                        'search',
                        'partials/footertoolbar/toolbarsearch',
                        false,
                        sectionIndex.savedSearches,
                        false
                    );
                }

                function extendSearch(s) {
                    return angular.extend(s, {
                        icon: icons[s.SearchType],
                        onClick: restoreSearch,
                        onDelete: deleteSearch
                    });
                }

                async function fetch() {
                    initialised = true;
                    const [
                        recentHotelIds,
                        shortlistEstabIds,
                        savedSearches,
                        footerToolbarPreferences
                    ] = await $q.all([
                        TRPCONFIG.Domain2.GetReviewedHotelsAPI ? recentHotels.getIds() : 0,
                        shortlistService.getShortlistEstabIds(),
                        TRPCONFIG.Domain2.GetSaveSearchesAPI ? savedSearchService.getSavedSearches() : null,
                        preferences.get('footerToolbar')
                    ]);
                    scope.sections = [
                        recentHotelsSection(recentHotelIds),
                        shortlistSection(shortlistEstabIds),
                        savedSearchesSection(savedSearches)
                    ];
                    return footerToolbarPreferences;
                }

                function rehydrate(section) {
                    return hotelRehydrator.hotels(section.estabIds, {
                        fields: [
                            'Id', 'Title', 'Location', 'StarRating', 'CustomerRating', 'CustomerRatingTitle', 'Url'
                        ]
                    }).then(function(hotels) {
                        for (let i = 0, l = hotels.length; i < l; i++) {
                            section.things[i] = hotels[i];
                            section.things[i].onDelete = section.onDelete;
                        }

                        section.needsHydrating = false;
                    });
                }

                function rehydrateHotel(section, id) {
                    return hotelRehydrator.hotels([id], {
                        fields: [
                            'Id', 'Title', 'Location', 'StarRating', 'CustomerRating', 'CustomerRatingTitle', 'Url'
                        ]
                    }).then(function(hotels) {
                        const hotel = hotels[0];
                        hotel.onDelete = section.onDelete;
                        return hotel;
                    });
                }

                function init() {
                    fetch().then(open => {
                        scope.open = open;
                        setupSubscriptions();
                    });
                }

                scope.select = function(index) {
                    scope.sections[index].open = false;
                };

                scope.sectionClass = function(index) {
                    return scope.sections[index].open ? 'expanded' : '';
                };

                scope.toggleBar = () => setToolbarOpen(!scope.open);

                scope.toggleSection = function(index) {
                    scope.sections.forEach(function(s, i) {
                        if (i !== index) {
                            s.open = false;
                        }
                    });

                    if (!scope.sections[index].open && scope.sections[index].needsHydrating) {
                        rehydrate(scope.sections[index]).then(function() {
                            scope.sections[index].open = true;
                        });
                    } else {
                        scope.sections[index].open = !scope.sections[index].open;
                    }
                };

                scope.$watch('open', function(v, o) {
                    if (v == null || v === o) {
                        return;
                    }
                    broker.publish('footerToolbarChanged', scope.open);
                });

                scope.$on('$destroy', function() {
                    broker.unsubscribe('footerToolbarDirective');
                });
            }
        };
    }
);
})();
